import { c as _c } from "react/compiler-runtime";
import UserPageErrorWrapper from "@/components/user/utils/UserPageErrorWrapper";
export default function UserPageRepNewRepError(t0) {
  const $ = _c(8);
  const {
    msg,
    closeError
  } = t0;
  let t1;
  if ($[0] !== msg) {
    t1 = <h3 className="tw-text-sm tw-mb-0 tw-font-semibold tw-text-red">{msg}</h3>;
    $[0] = msg;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div><p className="tw-text-justify tw-mt-2 tw-mb-0 tw-text-sm tw-text-iron-300 tw-font-normal">Rep is not meant for insults or doxxing so we run proposed rep categories through an AI filter. If you think the filter got your proposed category wrong, hop into Brain on 6529.io and let us know. In the meantime, perhaps you can rephrase that you are trying to say.</p></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <div className="tw-flex"><div className="tw-ml-3 tw-self-center tw-flex tw-flex-col lg:tw-max-w-xl">{t1}{t2}</div></div>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== closeError || $[6] !== t3) {
    t4 = <UserPageErrorWrapper closeError={closeError}>{t3}</UserPageErrorWrapper>;
    $[5] = closeError;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}